import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      data: [],
      props: {
        label: 'departmentName'
      }
    };
  },
  methods: {
    clickAddBuMen: function clickAddBuMen() {
      var _this = this;

      this.$prompt('请输入部门名称', '添加部门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '名称不为空'
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
          var value, params;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  value = _ref.value;
                  params = {
                    departmentName: value
                  };
                  _context.next = 4;
                  return _this.$api.saveDepartment(params);

                case 4:
                  _this.dataBind();

                  _this.$notify.success({
                    title: '成功',
                    message: '添加成功'
                  });

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    dataBind: function dataBind() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.departments();

              case 2:
                data = _context2.sent;
                _this2.data = data;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    append: function append(data) {
      var _this3 = this;

      this.$prompt('请输入部门名称', '添加部门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '名称不为空'
      }).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
          var value, params;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  value = _ref3.value;
                  params = {
                    parentId: data.departmentId,
                    departmentName: value
                  };
                  _context3.next = 4;
                  return _this3.$api.saveDepartment(params);

                case 4:
                  _this3.dataBind();

                  _this3.$notify.success({
                    title: '成功',
                    message: '添加成功'
                  });

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    editname: function editname(data) {
      var _this4 = this;

      this.$prompt('请输入部门名称', '重命名部门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '名称不为空'
      }).then( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5) {
          var value, params;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  value = _ref5.value;
                  params = {
                    departmentName: value,
                    departmentId: data.departmentId
                  };
                  _context4.next = 4;
                  return _this4.$api.saveDepartment(params);

                case 4:
                  _this4.dataBind();

                  _this4.$notify.success({
                    title: '成功',
                    message: '重命名成功'
                  });

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }());
    },
    remove: function remove(node, data) {
      var _this5 = this;

      this.$confirm('确认删除么？', '提示').then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.$api.deleteDepartment({
                  departmentId: data.departmentId
                });

              case 2:
                _this5.dataBind();

                _this5.$notify.success({
                  title: '成功',
                  message: '删除成功'
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    },
    renderContent: function renderContent(h, _ref8) {
      var _this6 = this;

      var node = _ref8.node,
          data = _ref8.data,
          store = _ref8.store;
      return h("span", {
        "class": "custom-tree-node"
      }, [h("span", [node.label]), h("span", [h("el-button", {
        "attrs": {
          "size": "mini",
          "type": "text"
        },
        "on": {
          "click": function click() {
            return _this6.append(data);
          }
        }
      }, ["\u65B0\u5EFA\u5B50\u90E8\u95E8"]), h("el-button", {
        "attrs": {
          "size": "mini",
          "type": "text"
        },
        "on": {
          "click": function click() {
            return _this6.editname(data);
          }
        }
      }, ["\u91CD\u547D\u540D"]), h("el-button", {
        "attrs": {
          "size": "mini",
          "type": "text"
        },
        "on": {
          "click": function click() {
            return _this6.remove(node, data);
          }
        }
      }, ["\u5220\u9664"])])]);
    }
  },
  created: function created() {
    this.dataBind();
  }
};